// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"488":"5d99c6b5c80b2573","1334":"51cb8859edd04be2"}[chunkId] + ".css";
};